import Immutable from 'immutable';

export const GET_CERTIFICATE = 'takeback/api/GET_CERTIFICATE';
export const GET_CERTIFICATE_SUCCESS = 'takeback/api/GET_CERTIFICATE_SUCCESS';
export const GET_CERTIFICATE_FAILURE = 'takeback/api/GET_CERTIFICATE_FAILURE';

const initialState = Immutable.OrderedMap();

// Reducers
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case GET_CERTIFICATE_SUCCESS:
        if (state.get('list')) {
            return state.set('list', state.get('list').merge(action.data.reduce((map, location) => {
                return map.set(location.getIn(['location', 'id']), location);
            }, Immutable.Map())));
        } else {
            return state.set('list', state.mergeDeep(action.data.reduce((map, location) => {
                return map.set(location.getIn(['location', 'id']), location);
            }, Immutable.Map())));
        }
    default:
        return state;
    }
}

// Actions
export function getCertificate(params = {}, options = {}) {
    return Object.assign({type: GET_CERTIFICATE, params}, options);
}

export function getCertificateSuccess(data) {
    return {type: GET_CERTIFICATE_SUCCESS, data};
}

export function getCertificateFailure(error) {
    return {type: GET_CERTIFICATE_FAILURE, error};
}

// Selectors
export function selectCertificate(state) {
    return state.certificate.get('list');
}
